import React from 'react';
import { CtaBlock } from './ui/CtaBlock';
import { BONUS_TOTAL, OFFER_ANCHOR, PACK_IMAGE, PRICE, PRODUCT_NAME } from '../data/content';
export function FinalCTA() {
  return <section aria-labelledby="cierre" className="border-b border-line bg-surface/40" data-id="element-54" data-mp="c6sm5lmdmgey">
      <div className="mx-auto max-w-xl px-4 py-8 text-center sm:py-10" data-id="element-55" data-mp="c4fuggqtgrop">
        <h2 id="cierre" className="font-display text-xl font-extrabold uppercase text-danger sm:text-2xl" data-id="element-56" data-mp="83m83rt0vkxx">
          Una última oportunidad
        </h2>
        <p className="mt-2 text-sm leading-snug text-muted" data-id="element-57" data-mp="h52gxv46vf01">
          Puedes seguir guardando videos sobre energizadores, puesta a tierra,
          aisladores, instalación y diagnóstico sin saber qué deberías aprender
          primero. O puedes comenzar hoy a construir una nueva habilidad
          siguiendo una ruta organizada desde cero.
        </p>
        <p className="mt-2 font-display text-sm font-semibold text-ink sm:text-base" data-id="element-58" data-mp="zwd1zvn8gxk0">
          No necesitas ser experto en cercos eléctricos para empezar. Necesitas
          dar el primer paso.
        </p>

        <div className="mt-4 rounded-2xl border-2 border-accent bg-surface p-4" data-id="element-59" data-mp="2h3hrgwu03ca2">
          <a href={OFFER_ANCHOR} aria-label="Ir a la sección de compra" className="mx-auto block max-w-[14rem] overflow-hidden rounded-xl transition-transform duration-150 ease-soft active:scale-[0.99]" data-id="element-60" data-mp="2m2uaf6hr3z7d">
            <img src={PACK_IMAGE} alt={`${PRODUCT_NAME}: 6 tomos digitales y 5 bonos incluidos`} className="block w-full" data-id="element-61" data-mp="2v2r63s2k5ybx" />
          </a>
          <p className="mt-3 font-display text-sm font-extrabold text-accent" data-id="element-62" data-mp="34udcnb3yb98c">
            ⚡ {PRODUCT_NAME}
          </p>
          <p className="mt-0.5 font-display text-sm font-semibold text-ink" data-id="element-63" data-mp="39rvk0x2blge8">6 Tomos + 5 Bonos</p>
          <p className="mt-1 text-sm text-muted" data-id="element-64" data-mp="3et2wvajbl5rr">
            Valor de los bonos: <span className="line-through" data-id="element-65" data-mp="3isbly23f0fgz">{BONUS_TOTAL}</span>
          </p>
          <p className="font-display text-3xl font-extrabold text-ink sm:text-4xl" data-id="element-66" data-mp="1jo3gleqt412g">
            Hoy: <span className="text-accent" data-id="element-67" data-mp="1ep8spydzfmbh">{PRICE}</span>
          </p>
          <CtaBlock note="Acceso Inmediato • Entrega Digital • Garantía de 7 Días" data-id="element-68" data-mp="1er3bb61s72ce" />
        </div>
      </div>
    </section>;
}